@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (betaaldePremieLijfrente.length > 0) {
      <div formArrayName="betaaldePremieLijfrente">
        @for (item of betaaldePremieLijfrente.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving premie lijfrente' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Polisnummer' : ''"
                                              class="custom-input-150"
                                              formControlName="polisnummer"
                                              id="polisnummer"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Bedrag' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedragLijfrente"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRijPremieLijfrente(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRijPremieLijfrente()"
                       class="snelstart-ui-button"
                       icon="plus"
                       type="link">Premie lijfrente toevoegen
  </snelstart-ui-button>

  @if (heeftVrijvalFor) {
    <form [formGroup]="formGroup" class="pt-2">
      @if (betaaldePremieLijfrenteFor.length > 0) {
        <div formArrayName="lijfrentePremiesFOR">
          @for (item of betaaldePremieLijfrenteFor.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Premie FOR/stakingswinst' : ''"
                                                  [options]="omschrijvingLijfrente"
                                                  class="custom-input-250"
                                                  formControlName="omschrijving"
                                                  id="omschrijving"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-text-form-control [label]="i === 0 ? 'Polisnummer' : ''"
                                                class="custom-input-150"
                                                formControlName="polisnummer"
                                                id="polisnummer"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedragLijfrente"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijPremieLijfrenteFor(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
              </div>
            </div>
          }
        </div>
      }
    </form>

    <snelstart-ui-button (click)="addRijPremieLijfrenteFor()" class="snelstart-ui-button" icon="plus"
                         type="link">Betaalde premie i.v.m. afname FOR/stakingswinst toevoegen
    </snelstart-ui-button>
  }
}
